import seoReducerMap from 'wanderu-ducks-seo';

import StateGuide from '../containers/StateGuide/StateGuide';

function onLoad(module, info, props, context) {
    context.store.inject(seoReducerMap);
}

export { onLoad };
export default StateGuide;
